// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"047da5fc","455":"88c7ed69","977":"fd8fe59a"}[chunkId] + ".chunk.js";
};